import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { Link } from "react-router-dom";
import Sidebar from "../../../partials/aside/Sidebar";
import TitleBar from "../../../partials/content/TitleBar";
import helperSpinner from "../../../../helpers/spinner";
import helperNumbers from "../../../../helpers/numbers";
import helperTime from "../../../../helpers/time";
import httpService from "../../../../services/httpServices/httpServices";
import StatusAskTransaction from "./../StatusAskTransaction";
import Pagination from "../../../partials/content/Pagination";

export default function AllAskTransaction() {
  const [allAskTransactionUserPublisher, setAllAskTransactionUserPublisher] =
    useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);
  const [askTransactionID, setAskTransactionID] = useState(0);

  useEffect(() => {
    getAllAskTransaction();
  }, [currentPage, askTransactionID]);

  const getAllAskTransaction = async () => {
    const userPublisherID = getUserPublisherID();
    if (!userPublisherID) {
      return;
    }
    const searchFilterQuery = getSearchFilterQuery();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let allAskTransaction = await sendRequestGetAllAskTransactionUserPublisher(
      userPublisherID,
      searchFilterQuery
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!allAskTransaction) {
      return;
    }

    setAllAskTransactionUserPublisher(allAskTransaction.ask_transaction);
    setCountPage(allAskTransaction.count_page);
  };

  const getSearchFilterQuery = () => {
    let searchFilterQuery = "";
    if (askTransactionID) {
      searchFilterQuery = `${searchFilterQuery}&id=${askTransactionID}`;
    }

    return searchFilterQuery;
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const sendRequestGetAllAskTransactionUserPublisher = async (
    userPublisherID,
    searchFilterQuery
  ) => {
    const headersRequest = getHeaderRequest();
    let allAskTransaction;
    try {
      allAskTransaction = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/manage/publisher/finance/ask-transaction/user-publisher/${userPublisherID}/paginate?page=${currentPage}&number=${countItemPerPage}${searchFilterQuery}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return allAskTransaction.data.data;
  };

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const getUserPublisherID = () => {
    const userPublisherID = parseInt(document.querySelector("#user-id").value);
    if (!userPublisherID) {
      return false;
    }
    return userPublisherID;
  };

  const generateDoseNotHaveAnyAskTransaction = () => {
    return (
      <div className="mt-2 alert alert-info">
        این کاربر هیچ درخواست انتقال وجه ای ندارد.
      </div>
    );
  };

  const generateAllAskTransactionUserPublisher = () => {
    return (
      <>
        <div className="alert alert-info mt-2">
          <div className="row pb-2">
            <div className="d-flex align-items-center">
              <div className="pl-2">
                <label>جستجو در شماره </label>
              </div>
              <div>
                <input
                  onKeyUp={(e) => setAskTransactionID(e.target.value)}
                  onWheel={(event) => event.currentTarget.blur()}
                  className="form-control"
                  type="number"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="table-responsive pt-2">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره درخواست</td>
                <td>مبلغ</td>
                <td>نام مالک حساب</td>
                <td>نام بانک</td>
                <td>وضعیت</td>
                <td>تاریخ ارسال درخواست</td>
                <td>عملیات</td>
              </tr>
            </thead>
            <tbody>
              {allAskTransactionUserPublisher.map((item, index) => {
                let classBadgeStatePage;
                switch (item.pat_status) {
                  case StatusAskTransaction.statusAskTransaction.PENDING:
                    classBadgeStatePage = "badge-warning";
                    break;
                  case StatusAskTransaction.statusAskTransaction.PAID:
                    classBadgeStatePage = "badge-info";
                    break;
                  case StatusAskTransaction.statusAskTransaction.REJECT:
                    classBadgeStatePage = "badge-danger";
                    break;
                }
                return (
                  <tr>
                    <td>{helperNumbers.toPersianNum(index + 1)}</td>
                    <td>{helperNumbers.toPersianNum(item.pat_id)}</td>
                    <td className="letter-spacing-finance-number">
                      {helperNumbers.toPersianNum(
                        helperNumbers.toFormatFinanceNumber(item.pat_price)
                      )}
                    </td>
                    <td>{item.pat_owner_account_name}</td>
                    <td>{item.pat_bank_name}</td>
                    <td>
                      <span className={`badge ${classBadgeStatePage}`}>
                        {
                          StatusAskTransaction.getStatusAskTransactionString()[
                            item.pat_status
                          ]
                        }
                      </span>{" "}
                    </td>
                    <td>
                      {helperNumbers.toPersianNum(
                        item.pat_created_at.split(" ")[1] +
                          " " +
                          helperTime.convertGregorianToJalali(
                            item.pat_created_at.split(" ")[0]
                          )
                      )}
                    </td>
                    <td>
                      <Link
                        to={`/finance/manage/ask-transaction/info/${item.pat_id}`}
                        className="btn btn-info"
                      >
                        <i className="fa fa-info"></i>
                      </Link>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {countPage > 1 ? generatePagination() : <></>}
      </>
    );
  };

  return (
    <>
      <Sidebar openItem="manage-finance" activeItem="all-ask-transaction" />

      <div className="content-wrapper">
        <TitleBar title="درخواست انتقال موجودی" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="w-50">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    getAllAskTransaction();
                  }}
                >
                  <div class="input-group ">
                    <input
                      type="text"
                      id="user-id"
                      class="form-control"
                      placeholder="شماره کاربر نمایش دهنده را وارد کنید"
                      required
                    />
                    <div class="input-group-append">
                      <button class="btn btn-primary" type="submit">
                        نمایش
                      </button>
                    </div>
                  </div>
                </form>
              </div>

              {allAskTransactionUserPublisher.length == 0 &&
              askTransactionID == 0
                ? generateDoseNotHaveAnyAskTransaction()
                : generateAllAskTransactionUserPublisher()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
